import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';
import { Heading } from '@spotahome/ui-library';

import CallToAction from './CallToAction';

import './Apply.scss';

const Apply = ({ headingText, descriptionText, actionUrl }) => (
  <div className="wrapper">
    <Heading size="large" text={headingText} className="mb-xl" />

    <p className="apply__description">{descriptionText}</p>

    <p className="apply__action">
      <CallToAction
        href={actionUrl}
        text={trans('home-checker.apply.action')}
      />
    </p>
  </div>
);

Apply.propTypes = {
  headingText: PropTypes.string.isRequired,
  descriptionText: PropTypes.string.isRequired,
  actionUrl: PropTypes.string.isRequired
};

export default Apply;
